<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="roleClaimForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                roleClaimForm: () => import('../forms/RoleClaimForm'),
                headers: [
                    { text: 'Role', value: 'roleId', table: 'roles', form: () => import('../forms/RoleForm') },
                    { text: 'Claim', value: 'claimId', table: 'claims', form: () => import('../forms/ClaimForm') },
                    { text: 'Access Level', value: 'accessLevel', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    claims: [],
                    roles: [],
                    items: []
                },
                sorting: [
                    { column: "roleId", direction: "ascending" },
                    { column: "claimId", direction: "ascending" },
                ],
                itemsField: 'roleClaims',
                editPageName: 'roleClaim',
                apiMethod: 'RoleClaims',
                claimName: 'RoleClaims',
                formTitle: 'Role Claim',
                excelTitle: 'Role Claims',
                hasEditPage: false,
            }
        },
    };
</script>
